// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ProfilePage_wrapper__3sLSk","buttons":"ProfilePage_buttons__tDLNK","content":"ProfilePage_content__1ANyY"};